<template>
  <div class="app-container">
    <!-- 搜索区 -->
    <div ref="topBox">
      <div class="formBox margbot">
        <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form" size="mini">
          <el-form-item label="年份:">
              <el-date-picker
              v-model="searchForm.yearDate"
              type="year"
              format="yyyy"
              value-format="yyyy"
              placeholder="请选择"
              :clearable="false"
              style="width:120px">
            </el-date-picker>
          </el-form-item>
          <div style="display: flex; align-items: center;">
            <div class="searchBtnBox">
              <el-form-item>
                <el-button type="primary" class="allBtn" @click="searchFn">查询</el-button>
                <el-button type="primary" class="allBtn" @click="resetForm">重置</el-button>
                <el-button type="primary" class="allBtn" @click="exportFn">导出</el-button>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <!-- 表格 -->
    <div class="table" :style="{ height: h }">
      <el-table :data="tableList" ref="table" height="100%" class="tableComent" border :row-class-name="rowClassName" v-loading="loading">
        <el-table-column type="index" width="55" label="序号"></el-table-column>
        <el-table-column prop="month" label="月份" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="interestAmount" label="贷款利息金额(万元)" min-width="160">
          <template slot="header">
            <el-tooltip content="计算方式：贷款利息金额 = 贷款本息明细中「实际扣款金额」的当月总和" placement="top">
              <span>贷款利息金额(万元)<i class="el-icon-question" style="margin-left:4px;color:#409EFF;"></i></span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="avgLoanAmount" label="平均贷款金额(万元)" min-width="180">
          <template slot="header">
            <el-tooltip content="计算方式：平均贷款金额 =（期初贷款剩余金额 + 期末贷款剩余金额）÷ 2。期初取当月1日 00:00:00 之前剩余贷款金额；期末取当月最后一天 23:59:59 之前剩余贷款金额。" placement="top">
              <span>平均贷款金额(万元)<i class="el-icon-question" style="margin-left:4px;color:#409EFF;"></i></span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="avgRate" label="平均利率(%)" min-width="160">
          <template slot="header">
            <el-tooltip content="计算方式：平均利率 = 贷款利息金额 ÷ 平均贷款金额 × 12" placement="top">
              <span>平均利率(%)<i class="el-icon-question" style="margin-left:4px;color:#409EFF;"></i></span>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { loanInfoAvgData } from '@/api/common-signature'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import global from '@/api/global'

export default {
  name: 'AvgLoanRate',
  data () {
    return {
      searchForm: {
        yearDate: new Date().getFullYear() + ''
      },
      tableList: [],
      loading: false,
      h: '500px'
    }
  },
  created () {
    this.getList()
  },
  mounted () {
    const topH = this.$refs.topBox ? this.$refs.topBox.offsetHeight : 120
    const pH = document.documentElement.clientHeight
    this.h = (pH - topH - 140) + 'px'
  },
  methods: {
    pickList (res) {
      if (!res) return []
      if (Array.isArray(res)) return res
      if (Array.isArray(res.list)) return res.list
      if (res.data && Array.isArray(res.data.list)) return res.data.list
      if (res.data && Array.isArray(res.data)) return res.data
      return []
    },
    // 合计行由接口返回（列表最后一行），此处仅给最后一行加样式
    rowClassName ({ rowIndex }) {
      if (rowIndex === this.tableList.length - 1) return 'total-row'
      return ''
    },
    getList () {
      this.loading = true
      const params = { year: this.searchForm.yearDate }
      loanInfoAvgData(params).then(res => {
        this.loading = false
        this.tableList = this.pickList(res)
      }).catch(err => {
        this.loading = false
        this.$message.error((err && (err.message || err.msg)) || '查询平均贷款利率失败')
      })
    },
    searchFn () {
      if (!this.searchForm.yearDate) {
        this.$message.warning('请选择年份')
        return
      }
      this.getList()
    },
    resetForm () {
      this.searchForm = {
        yearDate: new Date().getFullYear() + ''
      }
      this.getList()
    },
    exportFn () {
      // 表头配置写死（与贷款管理一致，无需用户弹框配置），随导出请求一起传给后端
      const header = [
        { name: '月份', key: 'month', width: 16, isWrap: true, type: 1 },
        { name: '贷款利息金额', key: 'interestAmount', width: 18, isWrap: true, type: 10 },
        { name: '平均贷款金额', key: 'avgLoanAmount', width: 18, isWrap: true, type: 10 },
        { name: '平均利率', key: 'avgRate', width: 16, isWrap: true, type: 1 }
      ]
      const url = global.smpName + '/loanInfo/exportAvgData'
      exportExcel(url, { year: this.searchForm.yearDate, header }, '平均贷款利率')
    }
  }
}
</script>

<style scoped lang="less">
.searchBtnBox {
  margin-left: 10px;
}
/deep/ .total-row {
  font-weight: bold;
  color: #409EFF;
}
</style>
